/**
 * Task copy is plain text. Titles, steps, and reminders do not use emoji.
 * CommonJS only. No object spread.
 */

const TASK_EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu;

function stripTaskEmoji(text) {
  return String(text || '')
    .replace(TASK_EMOJI, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/(^|\n)[ \t]+/g, '$1')
    .replace(/[ \t]{2,}/g, ' ');
}

module.exports = {
  stripTaskEmoji,
};
